export const setTitlePage = (page) => {
    window.document.title = process.env.REACT_APP_CompanyNameShort +' • ' + page;
}